import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { stream } from '@app/_models/stream';
import { Observable } from 'rxjs';
import { verifyDocument } from '@app/_models/verifyDocument';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
  // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  headers: new HttpHeaders(headervalue.headerWithJwt)
};
function _window() : any {
  // return the global native browser window object
  return window;
}

@Injectable({ providedIn: 'root' })


export class VerifyDocumentService {
  url: string;
  constructor(private http: HttpClient) { }

  get nativeWindow() : any {
    return _window();
 }

  getStream() {
    // return this.http.post<stream>(`${environment.apiUrl}/auth/getStreamMaster`,streamParam, httpOptions).pipe(
    // );
    //  alert("Stream");
    return this.http.get<stream[]>(`${environment.apiUrl}/auth/getStreamMaster`);

  }

  getEditVerifyDocData(val){
    return this.http.get<any>(`${environment.apiUrl}/student/getVerificationRequestById/${val}`);
    console.log("val====", val)
  }

  getVerificationDocsEmployee(userId, fromDate, toDate) {
    // let a = `${headervalue.headerWithJwt}`;
    // console.log('headervalue' + headervalue.headerWithJwt)



    // var userId = 526;
    console.log(userId);
    //getVerificationDataByUserid/{userId}/{fromDate}/{toDate}
    //return this.http.post<Register>(`${environment.apiUrl}/auth/studentSignUp`,RegisterParam, httpOptions).pipe(
    // var temp = this.http.get<any>(`${environment.apiUrl}/student/getVerificationDataByUserid/`+ userId);
    var temp = this.http.get<any>(`${environment.apiUrl}/employer/getVerificationDataByUserid/` + userId + '/' + fromDate + '/' + toDate,httpOptions);

    // return this.http.post<any>(`${environment.apiUrl}/employer/getVerificationDataByUserid/` + userId + '/' + fromDate + '/' + toDate, httpOptions).pipe();
    return temp;
  }

  getVerificationDocsSuperVerifier(fromDate, toDate) {
    let a = `${headervalue}`;
    console.log('headervalue' + headervalue.headerWithJwt)
  

    var temp = this.http.get<any>(`${environment.apiUrl}/superVerifier/getVerificationDocList/` + fromDate + '/' + toDate,httpOptions);
    return temp;
  }

  getVerificationDocs(userId) {
    let a = `${headervalue}`;
    console.log('headervalue' + headervalue.header)
   
    // var userId = 526;
    console.log(userId);
    //getVerificationDataByUserid/{userId}/{fromDate}/{toDate}

    var temp = this.http.get<any>(`${environment.apiUrl}/student/getVerificationDataByUserid/` + userId,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    // var temp = this.http.get<any>(`${environment.apiUrl}/student/getVerificationDataByUserid/` + userId, { headers:  new HttpHeaders( 
    //  { 'Content-Type': 'application/json',
    //   'Authorization': 'Bearer ' + localStorage.getItem('token') })})

    return temp;

  }

  saveVerificationDocs(formData) {
    // console.log("here")
    // const headers = new HttpHeaders()
    //   .set('Content-type', 'application/json');
    return this.http.post<any>(`${environment.apiUrl}/student/saveVerificationDocAndCalculateAmount`, { formData },httpOptions);
  }

  getStreams() {
    return this.http.get<any>(`${environment.apiUrl}/stream/getList`,httpOptions);
  }

  getColleges() {
    return this.http.get<any>(`${environment.apiUrl}/college/getList`,httpOptions);
  }

  getDocuments() {
    return this.http.get<any>(`${environment.apiUrl}/document/getList`,httpOptions);
  }

  getYearOfPassing() {
    return this.http.get<any>(`${environment.apiUrl}/yearOfPassing/getYearList`,httpOptions);
  }

  getRequestType() {
    return this.http.get<any>(`${environment.apiUrl}/requestType/getList`,httpOptions);
  }

  getBranch(id) {
    console.log("stream id service----", id)
    return this.http.get<any>(`${environment.apiUrl}/branch/getBranchList/`+id,httpOptions);
  }

  getEmbassy() {
    console.log("Embassy id service----")
    return this.http.get<any>(`${environment.apiUrl}/embassy/getEmbassyList/`,httpOptions);
  }
  getEmbassybyId(id){
    console.log("Embassy id service22----",id)
    return this.http.get<any>(`${environment.apiUrl}/embassy/getEmbassyList/`+id,httpOptions);
  }
  
  getSemester(id) {
    return this.http.get<any>(`${environment.apiUrl}/semester/getsemList/${id}`,httpOptions);
  }


  saveSingleVerificationDoc(verifyDocumentParam: verifyDocument) {

    return this.http.post<any>(`${environment.apiUrl}/student/saveStudentSingleVerificationDoc`, verifyDocumentParam, httpOptions);
  }
  downloadDF(applicationId) {
    // var userId = 526;
    console.log(applicationId);
    var temp = this.http.get<any>(`${environment.apiUrl}/student/exportinvoicepdf/` + applicationId,httpOptions);

    return temp;
  }

  getPDF(invoiceId: number): Observable<Blob> {
    this.url = `${environment.apiUrl}/student/exportinvoicepdf/` + invoiceId;
    // var authorization = 'Bearer ' + sessionStorage.getItem("access_token");

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   "Authorization": authorization, responseType: 'blob'
    // });

    return this.http.get<Blob>(this.url, {
      headers: headervalue.headerWithJwt, responseType:
        'blob' as 'json'
    });
  }

  saveStudentVerificationDoc(temp) {

    return this.http.post<any>(`${environment.apiUrl}/student/saveVerificationDocAndCalculateAmount`, temp, httpOptions);

  }

  //change -new api for update payment flag pallavi
  updateStudentVerificationPaymentFlag(temp) {

    return this.http.post<any>(`${environment.apiUrl}/student/updateVerificationPaymentDetails`, temp, httpOptions);

  }

  editVerificationRequest(data) {

    return this.http.put<any>(`${environment.apiUrl}/student/editVerificationRequest`, data, httpOptions);

  }
  getAmount(temp) {

    return this.http.post<any>(`${environment.apiUrl}/student/calDocPaymentAmt`, temp, httpOptions);

  }

 updateStudentVerificationDoc(ids) {

    return this.http.post<any>(`${environment.apiUrl}/student/updatePaymentflg`, ids, httpOptions);

  }

  uploadVerificationDocumentFile(formData: FormData) {

    // const tempHeader = {
    //   headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryyEmKNDsBKjB7QEqu' })
    // };

    return this.http.post<any>(`${environment.apiUrl}/student/uploadVerificationDocumentFile`, formData,{ headers: new HttpHeaders(headervalue.headerWithOnlyJwt) });

  }




}